class TiptapContentResolver {
  // eslint-disable-next-line no-useless-constructor
  constructor(resolve) {
    this.resolve = resolve;
  }
  static create(resolve) {
    return new TiptapContentResolver(resolve);
  }
}
export {
  TiptapContentResolver
};
//# sourceMappingURL=ContentResolver.js.map
